import React, { useState } from 'react'
import DrawerWithTitleAndFooter from '../../../components/drawer/DrawerWithTitleAndFooter'
import { AddNewCard } from './components/addnewcard/AddNewCard';
import { Elements } from '@stripe/react-stripe-js';
import { setShowManageCardDrawer } from '../DashboardSlice';
import { componentKey, setAddNewCard, setSelectedCard } from './ManageCardsSlice';
import Config from '../../../config.web';
import { loadStripe } from '@stripe/stripe-js';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getStripeSavedCards, saveCardDetails, setDefaultCard } from './ManageCardsSaga';
import SavedCardsList from '../../../components/savedcardslist/SavedCardsList';
import Loadable from '../../../components/loadable/Loadable';
import { MANAGE_CARDS_LOADING_STATES, MANAGE_CARDS_LOADING_STATES_MESSAGE_MAP } from './constants';

export default function ManageCards() {
  const { loadingState, stripeSavedCardsList, isAddNewCard, selectedCard } = useSelector((state) => state[componentKey])

  const handleClose = () => {
    dispatch(setShowManageCardDrawer(false));
  };
  
  const [stripePromise, setStripePromise] = useState(() => loadStripe(Config.STRIPE_PUBLISHABLE_KEY))

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getStripeSavedCards())
  }, [])

  const setCardAsDefault = (cardObj) => {
    dispatch(setDefaultCard(cardObj))
  }

  const handleSelectedCard = (cardObj) => {
    dispatch(setSelectedCard(cardObj))
  }

  return (
    <DrawerWithTitleAndFooter isOpen={true} onCloseCb={handleClose} title={"Manage Saved Cards"}>
      <Loadable currentState={loadingState.state} loadingStates={[MANAGE_CARDS_LOADING_STATES.SAVED_CARDS_LOADING, MANAGE_CARDS_LOADING_STATES.ADD_CARD_LOADING]} messageMap={MANAGE_CARDS_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
        <Elements stripe={stripePromise}>
          <AddNewCard showAddNewCard={isAddNewCard} setShowAddNewCardCb={(val) => dispatch(setAddNewCard(val))} />
        </Elements>

        <SavedCardsList isEditable={true} cardsList={stripeSavedCardsList} selectedCard={selectedCard} onSelectCb={handleSelectedCard} setAsDefaultCb={setCardAsDefault} />
      </Loadable>

    </DrawerWithTitleAndFooter>
  )
}